import React, { useEffect } from 'react'
import Head from 'next/head'
import Layout from 'layouts/Layout'
import browsee from '@browsee/web-sdk'
import { Provider } from 'react-redux'
import store from 'store'
import 'styles/global.scss'
import Script from 'next/script'
import { appWithTranslation } from 'next-i18next'
import { Crisp } from 'crisp-sdk-web'
import { Inter } from 'next/font/google'
import posthog from 'posthog-js'
import NextTopLoader from 'nextjs-toploader'
import nextI18NextConfig from '../next-i18next.config.js'

// Configure the Inter font with only necessary weights
const inter = Inter({
  subsets: ['latin'],
  weight: ['400', '500', '600', '700', '900'],
  display: 'swap',
  fallback: ['Helvetica', 'Arial', 'sans-serif'],
})

const MyApp = ({ Component, pageProps }) => {
  useEffect(() => {
    // Client-side only initializations
    if (typeof window !== 'undefined') {
      window.$crisp = []
      window.$crisp.push(['safe', true]) // Enable Crisp safe mode
      Crisp.configure('02a53bd8-a3fb-4556-b4bc-32f9cac6bbeb')

      // Initialize PostHog
      if (process.env.NEXT_PUBLIC_ENV === 'production') {
        posthog.init('phc_UvQGtK0gxmjLWY5amNfl4oG9QkDA1AuIAUYtIChLadA', {
          api_host: 'https://app.posthog.com', // Replace if using a self-hosted instance
          autocapture: true,
        })
        browsee.init({ apiKey: '85f79207478ecb88e58712125347f4cb06a173673dc7b036' })
      }
    }
    return () => {
      // Cleanup PostHog
      posthog?.reset() // Clears the current session and user information
    }
  }, [])

  const getLayout = Component.getLayout || ((page) => page)

  return getLayout(
    <Provider store={store}>
      <Head>
        <title>Styley</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Adapt, Convert And Scale Synthetic Media Efficiently" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      {process.env.NEXT_PUBLIC_ENV !== 'local' && (
        <Script id="ms-clarity" strategy="afterInteractive">
          {`
            (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window,document,"clarity","script","${
              process.env.NEXT_PUBLIC_BASE_URL === 'https://styley.ai' ? 'o3bhveqr5n' : 'g6s9tu7h6h'
            }");
          `}
        </Script>
      )}

      <div className={inter.className}>
        <Layout>
          <NextTopLoader color="#6529D1" initialPosition={0.02} />
          <Component {...pageProps} />
        </Layout>
      </div>
    </Provider>
  )
}

export default appWithTranslation(MyApp, nextI18NextConfig)
